import { Action } from '@nextforce/api'
import moment from 'moment-timezone'
import { NonAvailability, StoreUserNonAvailability } from './queries/types'
import { Cell } from './types'

export function formatTime(startTime: string, endTime: string) {
  return `${moment(startTime, 'HH:mm:ss').format('hA')} - ${moment(
    endTime,
    'HH:mm:ss'
  ).format('hA')}`
}

export function getWeekDaysShort() {
  return moment.weekdaysShort()
}

export function mapNonAvailabilityToCells(
  nonAvailability?: NonAvailability[]
): Cell[] {
  return (
    nonAvailability?.map(na => ({
      shiftBlockId: String(na.shiftBlock.id),
      dayOfWeek: String(na.dow),
    })) || []
  )
}

export function buildNonAvailabilityMutationAction(
  nonAvailability: StoreUserNonAvailability,
  action: Action
): Action {
  return {
    ...action,
    params: {
      ...action.params,
      id: nonAvailability.id,
      store_id: nonAvailability.store?.id,
      user_id: nonAvailability.user?.id,
    },
  }
}
